<template>
    <div v-if="barChartData" class="v-atlas-raster-geodata-time-series-panel">
        <!--#region Order buttons-->
        <ul class="v-list v-list-chips" style="margin-bottom:10px;">
            <li :class="`v-list__item ` + (orderBy == 'timestamp' ? 'x-selected' : '')">
                <div>
                    <button :data-tooltip="getOrderTooltip('Jahr')" @click="onOrderButtonClick('timestamp')">
                        {{ getOrderDirArrow('timestamp') }}
                        Jahr
                    </button>
                </div>
            </li>
            <li :class="`v-list__item ` + (orderBy == 'value' ? 'x-selected' : '')">
                <div>
                    <button :data-tooltip="getOrderTooltip('Wert')" @click="onOrderButtonClick('value')">
                        {{ getOrderDirArrow('value') }} Wert
                    </button>
                </div>
            </li>
        </ul>
        <!--#endregion Order buttons-->

        <div class="timeseries-scroll">
            <BarChartTable :bar-color-func="barColorFunc" :items="featuresOrdered"
                :label-func="(item) => item.timestamp" :value-func="(item) => item.value"
                :order-func="(item: any) => item[orderBy]" :order-dir="orderDir"
                :max-override="props.data?.allTimestamps?.max" :min-override="props.data?.allTimestamps?.min"
                @item-click="onItemClick" :number-format-options="{ numDecimals: 1 }"></BarChartTable>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import BarChartTable from "@/components/BarChartTable.vue";
import { getColorFunction, RasterGeodataQueryResponse } from "atlas-shared";
import { useSortedArray } from "gertrud";

const props = withDefaults(defineProps<{
    data: RasterGeodataQueryResponse | undefined
    rasterStyle?: string
}>(), {
    rasterStyle: "red-yellow-blue"
})

const emit = defineEmits(["item-click"])



const orderBy = ref<string>('timestamp')
const orderDir = ref<string>('desc')



const barChartData = computed(() => {
    if (!props.data?.timeSeries) return null;
    const entries = Object.entries(props.data.timeSeries)
        .filter(([, v]) => v !== null)
        .map(([timestamp, v]) => ({ timestamp, value: v as number }))

    return entries.length > 0 ? entries : null;
})

const featuresOrdered = useSortedArray(
    barChartData,
    (item: any) => item[orderBy.value],
    () => orderDir.value == "asc"
)

function barColorFunc(value: number) {

    const rgb = getColorFunction(props.rasterStyle)(value)
    return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`


}

function getOrderTooltip(fieldLabel: string) {
    const nextDir = orderDir.value === 'asc' ? 'desc' : 'asc';
    return nextDir === 'asc' ? `Aufsteigend nach ${fieldLabel} sortieren` : `Absteigend nach
                            ${fieldLabel} sortieren`;
}

function getOrderDirArrow(field: string) {
    if (orderBy.value === field) {
        return orderDir.value === 'asc' ? '▲' : '▼';
    }
    return '';
}


function onItemClick(item: any) {
    emit("item-click", item)
}

function onOrderButtonClick(field: string) {
    if (orderBy.value === field) {
        orderDir.value = orderDir.value === 'asc' ? 'desc' : 'asc';
    } else {
        orderBy.value = field;
    }
}


</script>
